// Enqueue modal

/*globals jQuery */
( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	// GALLERY
	window.MSR.galleryModal = ( function( $, undefined ) {
		var init = function() {
			if ( ! $.fn.magnificPopup ) {
				return;
			}

			$( '.gallery-item' ).magnificPopup( {
				type: 'image',
				closeBtnInside: true,
				closeMarkup: '<button class="mfp-close custom-bi-event" type="button" data-title="close gallery modal" data-interactionType="15" data-pgarea="body" data-cmpgrp="gallery modal" data-cmpnm="gallery"><span class="mfp-close">close gallery modal</span></button>',
				gallery: {
					enabled: true,
					arrowMarkup: '<button type="button" class="mfp-arrow mfp-arrow-%dir% custom-bi-event" data-title="%title%" data-pgarea="body" data-cmpgrp="gallery modal" data-cmpnm="gallery">%title%</button>',
					tPrev: 'Previous image', // title for left button
					tNext: 'Next image', // title for right button
					tCounter: '<span class="mfp-counter caption">%curr% of %total%</span>'
				},
				callbacks: {
					imageLoadComplete: function() {
						$( '.mfp-container .mfp-img' ).attr( 'tabindex', 0 ).focus();
					}
				},
				image: {
					titleSrc: 'data-caption'
				}
			} );
		};

		return {
			init: init
		};
	} )( jQuery );
} )();
